<template>
  <modal :id="modalId">

    <template v-slot:header>
      <i class="fa fa-check modal-icon"></i>
      <h4 class="modal-title">{{ title }}</h4>
    </template>

    <form :id="formId" :action="action" method="POST">

      <h3>Are you sure you would like to accept the claim?</h3>

      <input type="hidden" name="_method" value="PATCH">
      <input type="hidden" name="_token" :value="$csrf_token">
    </form>

    <template #footer>
      <button type="button" class="btn btn-default" @click="hideModal">
        <i class="fa fa-fw fa-close"></i> Cancel
      </button>
      <button type="submit" name="button_accept" class="btn btn-primary" :form="formId">
        <i class="fa fa-fw fa-save"></i> Accept
      </button>
    </template>

  </modal>
</template>

<script>
import HasModal from "./../mixins/HasModal";
export default {
  mixins: [HasModal],

  props: {

    // Modal dialog id.
    modalId: {
      required: false,
      type: String,
      default: 'acceptClaimModal'
    },

    // Form action URL.
    action: {
      type: String,
      default: ""
    },

    // Form title.
    title: {
      type: String,
      default: ""
    },

  },

  /**
   * Computed values
   */
  computed: {

    formId() {
      return this.modalId + "-form"
    }

  }
}
</script>
